<div class="container-fluid">
    <app-header titleText="Customer Metric" i18n-titleText>
        <div button class="float-right">
            <div *ngIf="!isRequesting">
                <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
                <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
            </div>
            <app-spinner [isRunning]="isRequesting"></app-spinner>
        </div>
    </app-header>

    <div *ngIf="report == null">
        <h5 i18n>Please provide report criteria</h5>
    </div>
    <div *ngIf="report != null">
        <div class="row header-text">

            <div class="col-md-4">
            </div>
            <div class="col-md-6 filter-zone">
                <p>
                    <span i18n>REPORT DEFINED:</span><br />
                    <span i18n>Date Range:</span> {{parameters.startDate | date: 'M/d/yyyy'}} - {{parameters.endDate | date: 'M/d/yyyy'}}<br />
                    <ng-template [ngIf]="dealer"><span i18n>Dealer:</span> {{dealer.dealer_BusinessName}}<br /></ng-template>
                    <ng-template [ngIf]="quoteStatus"><span i18n>Quote Status:</span> {{quoteStatus}}<br /></ng-template>
                </p>
            </div>
        </div>

        <div class="content">
            <div>
                <h2 i18n>Customer Metric</h2>
                <div>
                    <table class="table compact table-bidit">
                        <thead>
                            <tr>
                                <th i18n>Month</th>
                                <th i18n>Dealer</th>
                                <th i18n>Status</th>
                                <th i18n>Job Type</th>
                                <th i18n>Job $</th>
                                <th i18n>Avg Margin %</th>
                                <th i18n>Margin $</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let dealer of report">
                            <tr>
                                <td><strong>{{dealer.monthName}}</strong></td>
                                <td>{{dealer.dealer_BusinessName}}</td>
                                <td>{{dealer.quoteStatus}}</td>
                                <td>{{dealer.jobTypeDesc}}</td>
                                <td>${{dealer.totalCost | number: '1.2'}}</td>
                                <td>{{dealer.avgMargin * 100 | number: '1.2' }}%</td>
                                <td>${{dealer.quoteMargin | number: '1.2-2'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

